import { Account } from '@/domain/usecases'
import { CompanyManagerDashboard } from '@/domain/usecases/dashboard/company-manager/company-manager-dashboard'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import CompanyManagerBaseLoader from '@/main/routes/loaders/company-manager-base-loader'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'

export default class CompanyManagerDashboardLoader extends CompanyManagerBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined,
    readonly requiredFeatureFlag?: FeatureFlag.Key
  ) {
    super(account, undefined, queryClient, ldClient)
  }

  async loader() {
    return this.defer({
      data: super.importRemoteModule('makeRemoteCompanyManagerDashboard').then(async makeRemote => {
        const remote = makeRemote(this.queryClient) as CompanyManagerDashboard
        return remote.getDashboardList()
      })
    })
  }
}
